// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import TopMenu from './components/topMenu/TopMenu'
import Footer from './components/footer/Footer'
import Contact from './components/footer/Contact'
import isotopeGrid from './components/isotopeGrid/isotopeGrid'

import 'animate.css'
import 'fullpage-vue/src/fullpage.css'
import VueScrollTo from 'vue-scrollto'
import VueFullpage from 'fullpage-vue'
import isoTope from 'vueisotope'
import VueCarousel from 'vue-carousel'

Vue.config.productionTip = false

Vue.component('top-menu', TopMenu)
Vue.component('henkel-footer', Footer)
Vue.component('contact', Contact)
Vue.component('isotopegrid', isotopeGrid)
Vue.component('isotope', isoTope)
Vue.use(VueFullpage)
Vue.use(VueScrollTo)
Vue.use(VueCarousel)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: { switchCockroach: -1, switchCockroachTarget: 0 },
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js